// MARK: Enums

export enum TitleTypes {
    dr = 1,
    dre,
    mr,
    mme,
}

export enum HealthcareFacilityTypes {
    hospital = 1,
    pharmacy,
    clinic,
    gmf,
}

export enum StatusEnum {
    Draft = 1,
    Sent = 2,
    Billed = 3,
}

export enum TaskType {
    collaborator,
    questionnaire,
    tdm,
    externalBiomarker,
    counsellingAcknowledgement,
}

export * from './EmailErrorTypes';
export * from './QuestionnaireTypes';
